var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit",
    transform: "translate(-27.000000, -971.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Help-Icon",
    transform: "translate(28.000000, 972.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09,9 C9.57543688,7.62004444 10.9853836,6.79140632 12.4271763,7.0387121 C13.868969,7.28601788 14.9221794,8.53715293 14.9200034,10 C14.9200034,12 11.92,13 11.92,13",
    id: "Path",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#AFAFB1",
    x: 11,
    y: 16,
    width: 2,
    height: 2,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.98f67bbb767c7cda69df8ba90454010c.svg";
export { ForwardRef as ReactComponent };